import { useUploadAvatarMutation } from 'api/glob.api';
import { useDispatch } from 'react-redux';
import { formActions } from 'store/vaxFormDataSlice';
import PropTypes from 'prop-types';
import {
	useEditAvatarMutation,
	useRefreshTokenMutation,
} from 'api/internal.api.ts';
import { settingsActions } from 'store/settingsSlice.ts';
import { useEffect } from 'react';
import { setJWT, getCurrentUser } from 'service/user.service.js';
import { vaxEditDataActions } from 'store/vaxEditDataSlice.js';

const useUploadAvatar = (location) => {
	const dispatch = useDispatch();
	const [upload] = useUploadAvatarMutation();
	const [edit] = useEditAvatarMutation();
	const [refreshToken, { data: newToken, isSuccess: refreshTokenSuccess }] =
		useRefreshTokenMutation();
	useEffect(() => {
		if (!newToken || !refreshTokenSuccess) {
			return;
		}
		setJWT(newToken.token);
		dispatch(settingsActions.setUser(getCurrentUser()));
	}, [newToken]);
	const uploadAvatar = (formData, filename) => {
		if (location == 'register') {
			upload({
				body: formData,
				filename,
			})
				.unwrap()
				.then((result) => {
					dispatch(
						formActions.update({ avatar_glob_file_id: result.glob_file_id })
					);
				});
		} else if (location == 'user') {
			edit({
				body: formData,
				filename,
			})
				.unwrap()
				.then((result) => {
					dispatch(settingsActions.updateUser(result.glob_file_id));
					refreshToken();
				});
		} else if (location == 'edit') {
			upload({
				body: formData,
				filename,
			})
				.unwrap()
				.then((result) => {
					dispatch(
						vaxEditDataActions.update({
							avatar_glob_file_id: result.glob_file_id,
						})
					);
				});
		} else {
			upload({
				body: formData,
				filename,
			})
				.unwrap()
				.then((result) => {
					dispatch(
						formActions.update({
							avatar_glob_file_id: result.glob_file_id,
						})
					);
				});
		}
	};
	return uploadAvatar;
};

useUploadAvatar.propTypes = {
	internal: PropTypes.bool || PropTypes.undefined,
};

export default useUploadAvatar;
